import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { DashboardPartnerModel } from '../shared/models/dashboard.model';
import { DashboardService } from './dashboard.service';

@Injectable({
  providedIn: 'root'
})
export class DashboardResolverService  {

  constructor(private dashboardService: DashboardService) { }

  resolve(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<DashboardPartnerModel[]> {
    return this.dashboardService.getDashboard();
  }
}
